import { render, staticRenderFns } from "./doc-preview-dlg.vue?vue&type=template&id=367ce6d3&scoped=true"
import script from "./doc-preview-dlg.vue?vue&type=script&lang=js"
export * from "./doc-preview-dlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367ce6d3",
  null
  
)

export default component.exports